import Edit from "@mui/icons-material/Edit";
import { useSearchParams } from "react-router-dom";

import { STATIC_STRINGS } from "@asez/shared";

const PreviewCard = ({ title, children, stepNumber }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className="card border border-neutral-dark h-96 w-[280px] mr-2 mb-2">
      <div className="w-full flex items-center justify-between pb-2 h-[10%] border-b border-b-neutral-dark">
        <div className="font-semibold">{title}</div>
        <button
          className="text-neutral-dark hover:text-neutral-dark/70 cursor-pointer p-1 flex justify-center items-center"
          onClick={() => setSearchParams({ step: stepNumber })}
        >
          <Edit fontSize="small" className="mr-1" />
          {STATIC_STRINGS.EDIT}
        </button>
      </div>
      <div className="flex flex-col h-[90%] py-3 box-border">{children}</div>
    </div>
  );
};

export default PreviewCard;
